import React from "react";
import { Col, Form, Row, Spin } from "antd";
import CreateModal from "../../../core/ui/components/grid/CreateModal";
import UpdateModal from "../../../core/ui/components/grid/UpdateModal";
import OrganisationIndexConnectionForm from "./OrganisationIndexConnectionForm";
import OrganisationIndexGroupForm from "./OrganisationIndexGroupForm";
import OrganisationIndexForm from "./OrganisationIndexForm";
import OrganisationIndexGroupTree from "./OrganisationIndexGroupTree";
import { TOrganisationIndexPresentationModel } from "../../presenter/model/OrganisationIndexPresentationModel";
import { TIndexTypeGroupPresentationModel } from "../../presenter/model/IndexTypeGroupPresentationModel";
import { IStore } from "../../../core/model/runtime/state/Store";
import { IOrganisationIndexGroup } from "../../model/OrganisationIndexGroup";
import OrganisationIndexGroupConnectionForm from "./OrganisationIndexGroupConnectionForm";
import { TOrganisationIndexGroupPresentationModel } from "../../presenter/model/OrganisationIndexGroupPresentationModel";
import { TCaseLawDocumentPresentationModel } from "../../../caseLawDocuments/presenter/model/CaseLawDocumentPresentationModel";
import CaseLawDocsForOrgansationIndex from "./CaseLawDocsForOrgansationIndex";
import OrganisationIndexGroupSwithForm from "./OrganisationIndexGroupSwithForm";

interface OrganisationIndexGroupTreeViewProps {
  organisationIndexDataTree: TIndexTypeGroupPresentationModel[];
  createOrganisationIndexGroup;
  createOrganisationIndex;
  changeCreateGroupModalVisible: (
    value: boolean,
    indexTypeGroupId: number,
    organisationTypeGroupId: number
  ) => void;
  changeCreateItemModalVisible: (
    value: boolean,
    indexTypeId: number,
    organisationTypeGroupId: number
  ) => void;
  changeIndexesModalVisible: (value: boolean) => void;
  changeGroupsModalVisible: (value: boolean) => void;
  indexTypeGroupId: number;
  indexTypeId: number;
  createGroupModalVisible: boolean;
  createItemModalVisible: boolean;
  organisationId;
  translate;
  categoryId: number;
  loader;
  organisationTypeGroupId: number;
  searchDataTree: (searchValue: string) => void;
  indexesNotInOrganisation: TOrganisationIndexPresentationModel[];
  indexesModalVisible: boolean;
  groupsModalVisible: boolean;
  findConnectionCandidatesForIndex: any;
  findConnectionCandidatesForGroup: any;
  toggleConnected: any;
  toggleGroupConnected: any;
  connectIndexes: any;
  connectGroups: any;
  selectOrganisationIndex: any;
  selectOrganisationIndexGroup: any;
  changeUpdateIndexGroupModalVisible: any;
  clickedIndex?: TOrganisationIndexPresentationModel;
  clickedGroup?: IOrganisationIndexGroup;
  hierarchyList?: string[];
  connectedIndexes?: TOrganisationIndexPresentationModel[];
  connectedIndexGroups?: TOrganisationIndexGroupPresentationModel[];
  indexInfoVisible: boolean;
  groupInfoVisible: boolean;
  store: IStore;
  updateOrganisationIndex: any;
  changeUpdateIndexModalVisible: any;
  updateIndexModalVisible: boolean;
  updateIndexGroupModalVisible: boolean;
  updateOrganisationIndexGroup: any;
  searchFunction: any;
  searchGroupFunction: any;
  toggleFilterByParentName: any;
  groupModelsCandidates: TOrganisationIndexGroupPresentationModel[];
  toggleGroupFilterByParentName: any;
  canEdit: any;
  getCaseLawDocumentsForIndex: any;
  removeOrganisationIndex: any;
  caseLawDocuments?: TCaseLawDocumentPresentationModel[];
  caseLawDocsModalVisible: boolean;
  deleteWarningModalVisible: boolean;
  changeCaseLawDocsModalVisible: any;
  changeDeleteWarningModalVisible: any;
  showCaseLawDocumentDetails: any;
  getSwitchGroupCandidates: any;
  switchCandidates?: IOrganisationIndexGroup[];
  toggleSwitchGroup: any;
  selectedSwitchCandidate?: IOrganisationIndexGroup;
  changeSwitchGroupVisible: any;
  switchGroupVisible: boolean;
  switchGroupForIndex: any;
  searchSwitchGroupFunction: any;
  changeDeleteGroupVisible: any;
  changeDeleteGroupWarningVisible: any;
  checkCanGroupBeRemoved: any;
  deleteGroupModalVisible: boolean;
  deleteGroupWarningVisible: boolean;
  removeOrganisationIndexGroup: any;
  canSelectedIndexBeNonHarmonized?: boolean;
  connectionCandidatesByCategory?: TOrganisationIndexPresentationModel[];
  changeIndexesByCategoryModalVisible?: any;
  findConnectionCandidatesByCategory?: any;
  toggleConnectedByCategory: any;
  connectedIndexesByCategory: TOrganisationIndexPresentationModel[];
}
const OrganisationIndexGroupTreeView: React.FC<
  OrganisationIndexGroupTreeViewProps
> = ({
  organisationIndexDataTree,
  createOrganisationIndexGroup,
  createOrganisationIndex,
  changeCreateGroupModalVisible,
  changeCreateItemModalVisible,
  changeIndexesModalVisible,
  changeGroupsModalVisible,
  changeUpdateIndexGroupModalVisible,
  indexTypeGroupId,
  indexTypeId,
  createGroupModalVisible,
  createItemModalVisible,
  organisationId,
  translate,
  categoryId,
  organisationTypeGroupId,
  loader,
  searchDataTree,
  indexesNotInOrganisation,
  indexesModalVisible,
  groupsModalVisible,
  toggleConnected,
  toggleGroupConnected,
  connectIndexes,
  connectGroups,
  selectOrganisationIndex,
  selectOrganisationIndexGroup,
  clickedIndex,
  clickedGroup,
  hierarchyList,
  connectedIndexes,
  connectedIndexGroups,
  indexInfoVisible,
  groupInfoVisible,
  findConnectionCandidatesForIndex,
  findConnectionCandidatesForGroup,
  store,
  updateOrganisationIndex,
  changeUpdateIndexModalVisible,
  updateIndexModalVisible,
  updateIndexGroupModalVisible,
  updateOrganisationIndexGroup,
  searchFunction,
  searchGroupFunction,
  toggleFilterByParentName,
  groupModelsCandidates,
  toggleGroupFilterByParentName,
  canEdit,
  getCaseLawDocumentsForIndex,
  removeOrganisationIndex,
  caseLawDocuments,
  caseLawDocsModalVisible,
  deleteWarningModalVisible,
  changeCaseLawDocsModalVisible,
  changeDeleteWarningModalVisible,
  showCaseLawDocumentDetails,
  switchCandidates,
  toggleSwitchGroup,
  changeSwitchGroupVisible,
  switchGroupVisible,
  getSwitchGroupCandidates,
  switchGroupForIndex,
  searchSwitchGroupFunction,
  changeDeleteGroupVisible,
  changeDeleteGroupWarningVisible,
  checkCanGroupBeRemoved,
  deleteGroupModalVisible,
  deleteGroupWarningVisible,
  removeOrganisationIndexGroup,
  canSelectedIndexBeNonHarmonized,
  connectionCandidatesByCategory,
  changeIndexesByCategoryModalVisible,
  findConnectionCandidatesByCategory,
  toggleConnectedByCategory,
  connectedIndexesByCategory
}) => {
  const [CreateGroupForm] = Form.useForm();
  const [CreateIndexForm] = Form.useForm();
  const [CreateIndexConnectionForm] = Form.useForm();
  const [CreateGroupConnectionForm] = Form.useForm();
  const [UpdateIndexForm] = Form.useForm();
  const [UpdateIndexSwitchForm] = Form.useForm();
  const [UpdateIndexGroupForm] = Form.useForm();
  const [CaseLawDocumentsForm] = Form.useForm();
  const [DeleteForm] = Form.useForm();
  const [DeleteGroupForm] = Form.useForm();
  const [DeleteGroupWarningForm] = Form.useForm();
  return (
    <Spin spinning={loader}>
      <div>
        <Row className={"tree-container"}>
          <Col span={24}>
            <OrganisationIndexGroupTree
              translate={translate}
              searchDataTree={searchDataTree}
              organisationIndexDataTree={organisationIndexDataTree}
              changeCreateGroupModalVisible={changeCreateGroupModalVisible}
              changeCreateItemModalVisible={changeCreateItemModalVisible}
              selectOrganisationIndex={selectOrganisationIndex}
              selectOrganisationIndexGroup={selectOrganisationIndexGroup}
              indexInfoVisible={indexInfoVisible}
              groupInfoVisible={groupInfoVisible}
              hierarchyList={hierarchyList}
              connectedIndexes={connectedIndexes}
              connectedIndexGroups={connectedIndexGroups}
              clickedIndex={clickedIndex}
              clickedGroup={clickedGroup}
              findConnectionCandidatesForIndex={
                findConnectionCandidatesForIndex
              }
              findConnectionCandidatesForGroup={
                findConnectionCandidatesForGroup
              }
              changeUpdateIndexModalVisible={changeUpdateIndexModalVisible}
              changeUpdateIndexGroupModalVisible={
                changeUpdateIndexGroupModalVisible
              }
              canEdit={canEdit}
              getCaseLawDocumentsForIndex={getCaseLawDocumentsForIndex}
              removeOrganisationIndex={removeOrganisationIndex}
              caseLawDocuments={caseLawDocuments}
              getSwitchGroupCandidates={getSwitchGroupCandidates}
              checkCanGroupBeRemoved={checkCanGroupBeRemoved}
              connectionCandidatesByCategory={connectionCandidatesByCategory}
              changeIndexesByCategoryModalVisible={
                changeIndexesByCategoryModalVisible
              }
              findConnectionCandidatesByCategory={
                findConnectionCandidatesByCategory
              }
              connectedIndexesByCategory={connectedIndexesByCategory}
            />
          </Col>
        </Row>
        <CreateModal
          translate={translate}
          title={translate("editors.organisations.index_group")}
          visible={createGroupModalVisible}
          onCancel={() => {
            changeCreateGroupModalVisible(false, NaN, NaN);
            CreateGroupForm.resetFields();
          }}
          onCreate={createOrganisationIndexGroup}
          Form={
            <OrganisationIndexGroupForm
              translate={translate}
              form={CreateGroupForm}
              indexTypeGroupId={indexTypeGroupId}
              organisationId={organisationId}
              categoryId={categoryId}
              parentId={organisationTypeGroupId}
              store={store}
            />
          }
          formInstance={CreateGroupForm}
          className={"modal-width"}
          okText={translate("data_grid.modal.actions.save")}
          cancelText={translate("data_grid.modal.actions.cancel")}
        />
        <CreateModal
          translate={translate}
          title={translate("editors.organisations.index")}
          visible={createItemModalVisible}
          onCancel={() => {
            changeCreateItemModalVisible(false, NaN, NaN);
            CreateIndexForm.resetFields();
          }}
          onCreate={createOrganisationIndex}
          Form={
            <OrganisationIndexForm
              translate={translate}
              form={CreateIndexForm}
              indexTypeId={indexTypeId}
              organisationId={organisationId}
              groupId={organisationTypeGroupId}
              store={store}
            />
          }
          formInstance={CreateIndexForm}
          className={"modal-width"}
          okText={translate("data_grid.modal.actions.save")}
          cancelText={translate("data_grid.modal.actions.cancel")}
        />
        <CreateModal
          Form={
            <OrganisationIndexConnectionForm
              indexes={indexesNotInOrganisation}
              translate={translate}
              toggleConnected={toggleConnected}
              form={CreateIndexConnectionForm}
              clickedIndex={clickedIndex}
              searchFunction={searchFunction}
              toggleFilterByParentName={toggleFilterByParentName}
              description={translate(
                "editors.organisation_indexes.connect_message"
              )}
            />
          }
          translate={translate}
          visible={indexesModalVisible}
          className={"modal-width"}
          formInstance={CreateIndexConnectionForm}
          onCreate={connectIndexes}
          onCancel={() => {
            changeIndexesModalVisible(false);
            CreateIndexConnectionForm.resetFields();
          }}
        />
        <CreateModal
          Form={
            <OrganisationIndexGroupConnectionForm
              groups={groupModelsCandidates}
              translate={translate}
              toggleConnected={toggleGroupConnected}
              form={CreateGroupConnectionForm}
              createOrganisationIndexGroup={createOrganisationIndexGroup}
              clickedGroup={clickedGroup}
              searchGroupFunction={searchGroupFunction}
              toggleGroupFilterByParentName={toggleGroupFilterByParentName}
            />
          }
          translate={translate}
          visible={groupsModalVisible}
          className={"modal-width"}
          formInstance={CreateGroupConnectionForm}
          onCreate={connectGroups}
          onCancel={() => {
            changeGroupsModalVisible(false);
            CreateGroupConnectionForm.resetFields();
          }}
        />
        <UpdateModal
          Form={
            <OrganisationIndexForm
              translate={translate}
              form={UpdateIndexForm}
              indexTypeId={indexTypeId}
              organisationId={organisationId}
              groupId={organisationTypeGroupId}
              store={store}
              canSelectedIndexBeNonHarmonized={canSelectedIndexBeNonHarmonized}
              connectionCandidatesByCategory={connectionCandidatesByCategory}
              toggleConnectedByCategory={toggleConnectedByCategory}
              connectedIndexesByCategory={connectedIndexesByCategory}
            />
          }
          translate={translate}
          title={translate("editors.organisations.update_modal")}
          visible={updateIndexModalVisible}
          className={"modal-width"}
          formInstance={UpdateIndexForm}
          rowData={clickedIndex}
          onUpdate={updateOrganisationIndex}
          onCancel={() => {
            changeUpdateIndexModalVisible(false);
            UpdateIndexForm.resetFields();
          }}
        />
        <UpdateModal
          Form={
            <OrganisationIndexGroupForm
              translate={translate}
              form={UpdateIndexGroupForm}
              indexTypeGroupId={indexTypeGroupId}
              organisationId={organisationId}
              categoryId={categoryId}
              parentId={organisationTypeGroupId}
              store={store}
            />
          }
          translate={translate}
          title={translate("editors.organisations.update_modal")}
          visible={updateIndexGroupModalVisible}
          className={"modal-width"}
          rowData={clickedGroup}
          formInstance={UpdateIndexGroupForm}
          onUpdate={updateOrganisationIndexGroup}
          onCancel={() => {
            changeUpdateIndexGroupModalVisible(false);
            UpdateIndexGroupForm.resetFields();
          }}
        />
        {caseLawDocuments !== undefined && (
          <CreateModal
            Form={
              <CaseLawDocsForOrgansationIndex
                caseLawDocuments={caseLawDocuments}
                showCaseLawDocumentDetails={showCaseLawDocumentDetails}
                translate={translate}
              />
            }
            translate={translate}
            visible={caseLawDocsModalVisible}
            className={"modal-width"}
            formInstance={CaseLawDocumentsForm}
            onCreate={() => changeCaseLawDocsModalVisible(false)}
            onCancel={() => {
              changeCaseLawDocsModalVisible(false);
              CreateGroupConnectionForm.resetFields();
            }}
          />
        )}
        <CreateModal
          Form={
            <div>
              {translate("editors.organisation_indexes.delete_warning")}
            </div>
          }
          translate={translate}
          visible={deleteWarningModalVisible}
          className={"modal-width"}
          formInstance={DeleteForm}
          onCreate={() => removeOrganisationIndex()}
          onCancel={() => {
            changeDeleteWarningModalVisible(false);
            DeleteForm.resetFields();
          }}
        />
        {switchCandidates && (
          <UpdateModal
            Form={
              <OrganisationIndexGroupSwithForm
                groups={switchCandidates}
                translate={translate}
                toggleSwitchGroup={toggleSwitchGroup}
                form={UpdateIndexSwitchForm}
                searchGroupFunction={searchSwitchGroupFunction}
              />
            }
            rowData={clickedIndex}
            translate={translate}
            visible={switchGroupVisible}
            className={"modal-width"}
            formInstance={UpdateIndexSwitchForm}
            onUpdate={switchGroupForIndex}
            onCancel={() => {
              changeSwitchGroupVisible(false);
              UpdateIndexSwitchForm.resetFields();
            }}
          />
        )}
        <CreateModal
          Form={
            <div>
              {translate("editors.organisation_index_groups.delete_warning")}
            </div>
          }
          translate={translate}
          visible={deleteGroupWarningVisible}
          className={"modal-width"}
          formInstance={DeleteGroupForm}
          onCreate={() => changeDeleteGroupWarningVisible(false)}
          onCancel={() => {
            changeDeleteGroupWarningVisible(false);
            DeleteGroupForm.resetFields();
          }}
        />
        <CreateModal
          Form={
            <div>
              {translate("editors.organisation_index_groups.delete_message")}
            </div>
          }
          translate={translate}
          visible={deleteGroupModalVisible}
          className={"modal-width"}
          formInstance={DeleteGroupWarningForm}
          onCreate={() => removeOrganisationIndexGroup()}
          onCancel={() => {
            changeDeleteGroupVisible(false);
            DeleteGroupWarningForm.resetFields();
          }}
        />
      </div>
    </Spin>
  );
};
export default OrganisationIndexGroupTreeView;
